<template>
  <div class="features-list">
    <div
      v-for="(feature, index) in features"
      :key="index"
      class="feature-item"
      :class="{ 'full-width': feature.fullWidth }"
    >
      <div class="feature-icon">
        <img :src="feature.icon" :alt="feature.text" />
      </div>
      <span class="feature-text">{{ feature.text }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
  interface Feature {
    icon: string
    text: string
    fullWidth?: boolean
  }

  defineProps<{
    features: Feature[]
  }>()
</script>

<style lang="scss" scoped>
  .features-list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-bottom: 24px;

    @include vp-767 {
      grid-template-columns: 1fr;
    }

    > .feature-item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 16px 12px;
      background: #eafae5;
      border-radius: 12px;

      &.full-width {
        grid-column: 1 / -1;
      }

      > .feature-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        flex-shrink: 0;

        > img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      > .feature-text {
        font-family: Onest, sans-serif;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #000;
      }
    }
  }
</style>
